<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <!--<li class="">
                <router-link v-bind:to="{name: 'ListSlider',params:{type:'home'}}"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-home fa-stack-1x "></i></span>Home Slider</router-link>
            </li>-->
            <template v-show="roleId <= 1 || userPermissions.indexOf('access_social_media_calendar') > -1"></template>
            <li v-show="roleId <= 1" id="li_home" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-home fa-stack-1x "></i></span> Home <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_home" class="nav nav-list tree" style="display: none;">
                    <li id="home_list_slider"><router-link v-bind:to="{name: 'ListSlider',params:{type:'home'}}">Home Slider</router-link></li>
                </ul>
            </li>
            <li v-show="roleId <= 1" id="li_benefit" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-clock-o fa-stack-1x "></i></span> Benefits <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_benefits" class="nav nav-list tree">
                    <li id="benefits"><router-link v-bind:to="{ path:'/backend/listbenefits'}" > View Benefits </router-link></li>
                    <li id="draggable_benefits"><router-link v-bind:to="{ path:'/backend/listdraggablebenefits'}" > Draggable Benefits List </router-link></li>
                    <li id="benefit_type"><router-link v-bind:to="{ path:'/backend/listbenefittypes'}" > View Benefit Types </router-link></li>
                    <li id="benefit_provider"><router-link v-bind:to="{ path:'/backend/listbenefitproviders'}" > View Benefit Providers </router-link></li>
                    <li id="benefit_video"><router-link v-bind:to="{ path:'/backend/listbenefitvideos'}" > View Benefit Videos </router-link></li>
                    <li id="benefit_site"><router-link v-bind:to="{ path:'/backend/listbenefitsite'}" > View Benefit Sites </router-link></li>
                    <li id="benefit_glance"><router-link v-bind:to="{name: 'ListBenefitGlance'}" > View Benefit Glance </router-link></li>
                    <li id="benefit_slider"><router-link v-bind:to="{name: 'ListSlider',params:{type:'benefit'}}">Benefit Slider</router-link></li>
                    <li id="benefit_glance"><router-link v-bind:to="{name: 'ListBenefitSupports'}" > View Benefit Supports</router-link></li>
                    <li id="benefit_communications"><router-link v-bind:to="{name: 'ListBenefitCommunications'}" > View Benefit Communications</router-link></li>
                </ul>
            </li>
            <!--<li class="" v-show="userPermissions.indexOf('access_social_media_calendar') > -1" id="li_event">
                <router-link v-bind:to="{name: 'HelloWorld'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-calendar-plus-o fa-stack-1x "></i></span>Social Media Calendar</router-link>
            </li>-->
            <li class="" v-show="roleId <= 1" id="li_event">
                <router-link v-bind:to="{name: 'ListEvent'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-calendar fa-stack-1x "></i></span>Events</router-link>
            </li>
            <li v-show="roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1" id="li_user" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-users fa-stack-1x "></i></span> Users <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_user" class="nav nav-list tree" style="display: none;">
                    <li v-show="roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1" id="user"><router-link v-bind:to="{name: 'ListUser'}"> Registered Users</router-link></li>
                    <li v-show="roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1" id="not_registered_user"><router-link v-bind:to="{name: 'ListNotRegisteredUser'}"> New Users</router-link></li>
                    <li v-show="roleId <= 1 || userPermissions.indexOf('allow_user_management_module') > -1" id="notification"><router-link v-bind:to="{name: 'ListNotification'}"> Notifications</router-link></li>
                </ul>
            </li>
            <li v-show="roleId <= 0 || userPermissions.indexOf('add_contact_extension') > -1" id="li_contact_extension" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-folder-open-o fa-stack-1x "></i></span> Extension Directory <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_user" class="nav nav-list tree" style="display: none;">
                    <template v-show="roleId <= 0 || userPermissions.indexOf('add_location_departments') > -1">
                        <li id="company_list"><router-link v-bind:to="{name: 'CompanyList'}">Company</router-link></li>
                        <li id="location_list"><router-link v-bind:to="{name: 'LocationList'}">Location</router-link></li>
                        <li id="department_list"><router-link v-bind:to="{name: 'DepartmentsList'}">Department</router-link></li>
                    </template>
                    <li id="location_contact_list"><router-link v-bind:to="{name: 'LocationListContact'}">Location Contact List</router-link></li>
                    <li id="department_contact_list"><router-link v-bind:to="{name: 'DepartmentListContact'}">Department Contact List</router-link></li>
                    <li id="user_contact_list"><router-link v-bind:to="{name: 'ListContact'}">User Contact List</router-link></li>
                </ul>
            </li>
            <!--<li v-show="userPermissions.indexOf('add_location_departments') > -1" id="li_location_department" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-pin fa-stack-1x "></i></span> Manage Location <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_user" class="nav nav-list tree" style="display: none;">
                    <li id="company_list"><router-link v-bind:to="{name: 'CompanyList'}">Company</router-link></li>
                    <li id="location_list"><router-link v-bind:to="{name: 'LocationList'}">Location</router-link></li>
                    <li id="department_list"><router-link v-bind:to="{name: 'DepartmentsList'}">Department</router-link></li>
                </ul>
            </li>-->
            <li v-show="roleId <= 1" id="li_gallery" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-picture-o fa-stack-1x "></i></span> Gallery <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_gallery" class="nav nav-list tree" style="display: none;">
                    <li id="videos"><router-link v-bind:to="{name: 'ListVideos'}">List Videos</router-link></li>
                    <li id="images"><router-link v-bind:to="{name: 'ListMedia'}">List Images</router-link></li>
                    <li id="images"><router-link v-bind:to="{name: 'ImageListForApproval'}">Images For Approval</router-link></li>
                    <!-- <li id="media"><router-link v-bind:to="{name: 'AddMedia'}">Add Media</router-link></li> -->
                    <li id="category_gallery"><router-link v-bind:to="{name: 'ListCategory',params:{type:'gallery'}}">List Category</router-link></li>
                </ul>
            </li>
            <li v-show="roleId <= 1" id="li_discount" class="">
                <router-link v-bind:to="{name: 'ListDiscount'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-ticket fa-stack-1x "></i></span>Employee Perks</router-link>
            </li>
            <li v-show="roleId <= 1" id="li_wellness" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-heartbeat fa-stack-1x "></i></span> Wellness <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_wellness" class="nav nav-list tree" style="display: none;">
                    <li id="wellness"><router-link v-bind:to="{name: 'ListWellness'}">List Wellness</router-link></li>
                    <!--<li><router-link v-bind:to="{name: 'ListWellnessSlider'}">List Slider old</router-link></li>-->
                    <li id="wellness_slider"><router-link v-bind:to="{name: 'ListSlider',params:{type:'wellness'}}">List Slider</router-link></li>
                </ul>
            </li>

            <li v-show="roleId <= 2" id="li_talent" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left">
                <i class="fa fa-star-half-o fa-stack-1x" aria-hidden="true"></i>
                <!--img src="/static/images/talent_profile_menu.png" alt="Talent Profile Management"-->
                </span> Talent Management <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_talent" class="nav nav-list tree" style="display: none;">
                    <li id="ninebox"><router-link v-bind:to="{name: 'NineBox'}">9-Box</router-link></li>
                    <li id="ninebox"><router-link v-bind:to="{name: 'ListTalentProfile'}">Talent Profiles</router-link></li>
                </ul>
            </li>






            <li v-show="roleId <= 1" id="li_leadership" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left">
                <i class="fa fa-cubes fa-stack-1x "></i></span> Leadership Development <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_leadership" class="nav nav-list tree" style="display: none;">
                    <li id="leadership"><router-link v-bind:to="{name: 'ListLeadershipDevelopment'}">List</router-link></li>
                    <!--<li><router-link v-bind:to="{name: 'ListLeadershipMedia'}">Change Sequence</router-link></li>-->
                    <li id="category_leadership"><router-link v-bind:to="{name: 'ListCategory',params:{type:'leadership'}}">Categories</router-link></li>
                </ul>
            </li>
            <li v-show="roleId <= 1" id="li_dayforce" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-film fa-stack-1x "></i></span> Dayforce 101 <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_dayforce" class="nav nav-list tree" style="display: none;">
                    <li id="dayforce"><router-link v-bind:to="{name: 'ListDayforce101'}">List</router-link></li>
                    <li id="category_dayforce"><router-link v-bind:to="{name: 'ListCategory',params:{type:'dayforce'}}">Categories</router-link></li>
                    <li id="dayforce_doc"><router-link v-bind:to="{name: 'ListDayforce101Docs'}">List Documents</router-link></li>
                    <li id="dayforce_block_list"><router-link v-bind:to="{name: 'BlockListViewDayforceDoc'}">Draggable List</router-link></li>
                </ul>
            </li>
            <li v-show="roleId <= 1" id="li_401k" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-money fa-stack-1x "></i></span> 401K <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_401k" class="nav nav-list tree" style="display: none;">
                    <li id="update_401k"><router-link v-bind:to="{name: 'ViewUpdate401k'}">401K</router-link></li>
                    <li id="video_401k"><router-link v-bind:to="{name: 'List401kVideos'}">401K Videos</router-link></li>
                    <!--<li><router-link v-bind:to="{name: 'List401kSlider'}">401K Slider Old</router-link></li>-->
                    <li id="slider_401k"><router-link v-bind:to="{name: 'ListSlider',params:{type:'401k'}}">401K Slider</router-link></li>
                    <li id="category_401k"><router-link v-bind:to="{name: 'ListCategory',params:{type:'401k'}}">List Category</router-link></li>
                </ul>
            </li>
            <li v-show="roleId <= 1" id="li_policies" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-file-text fa-stack-1x "></i></span> Policies And Forms <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_policies" class="nav nav-list tree" style="display: none;">
                    <li id="policies"><router-link v-bind:to="{name: 'ListPoliciesAndForms'}">List</router-link></li>
                    <li id="policies_block_list"><router-link v-bind:to="{name: 'BlockListViewPoliciesForms'}">Draggable List</router-link></li>
                </ul>
            </li>
            <li v-show="roleId <= 1" id="li_survey" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-bar-chart fa-stack-1x "></i></span> Surveys <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_survey" class="nav nav-list tree" style="display: none;">
                    <li id="survey"><router-link v-bind:to="{name: 'ListSurveys'}">List</router-link></li>
                    <li id="survey_block_list"><router-link v-bind:to="{name: 'BlockListViewSurveys'}">Draggable List</router-link></li>
                </ul>
            </li>

            <li v-show="roleId <= 1" id="li_survey" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-bar-chart fa-stack-1x "></i></span> ERG's <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_erg" class="nav nav-list tree" style="display: none;">
                    <li id="ergs"><router-link v-bind:to="{name: 'ListERGs'}">List</router-link></li>
                    <!--li id="ergs_block_list"><router-link v-bind:to="{name: 'BlockListViewERGs'}">Draggable List</router-link></li-->
                </ul>
            </li>

            <!--li v-show="roleId <= 1" id="li_nine" class="">
                <router-link v-bind:to="{name: 'NineBox'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-th fa-stack-1x "></i></span>9-Box</router-link>
            </li-->


            <li v-show="roleId <= 1" id="li_FAQ" class="">
                <router-link v-bind:to="{name: 'DraggableListFAQ'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-question-circle fa-stack-1x "></i></span>FAQs</router-link>
            </li>
            <li v-show="roleId <= 1" id="li_contacthr" class="">
                <router-link v-bind:to="{name: 'UpdateContactHR'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-phone fa-stack-1x "></i></span>Contact HR</router-link>
            </li>
            <li v-show="roleId <= 1" id="li_contacthr" class="">
                <router-link v-bind:to="{name: 'ListArchived'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-archive fa-stack-1x "></i></span>Archived Documents</router-link>
            </li>
            <li v-show="roleId <= 0 || userPermissions.indexOf('allow_forum_module') > -1" id="li_survey" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-comments-o fa-stack-1x"></i></span> Forum <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_survey" class="nav nav-list tree" style="display: none;">
                    <li id="Questions"><router-link v-bind:to="{name: 'ListForumQuestions'}">Posts</router-link></li>
                    <li id="comments"><router-link v-bind:to="{name: 'ListForumComments'}">comments</router-link></li>
                </ul>
            </li>
            <!-- This is commented on 29-12-2023 considering that its not in use
            and also due to facebook/graph-sdk package is used for php 7.2 but its not upgradable to php 8.1 -->
            <!-- <li v-show="roleId <= 1 || userPermissions.indexOf('review_social_media') > -1" id="social_mgmt" class="">
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-tags fa-stack-1x"></i></span> Social Media Management <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul id="ul_survey" class="nav nav-list tree" style="display: none;">
                    <li id="social"><router-link v-bind:to="{name: 'SocialAccounts'}">Social Accounts</router-link></li>
                    <li id="timeline"><router-link v-bind:to="{name: 'PostTimeline'}">Social Accounts Timeline</router-link></li>
                    <li id="timeline"><router-link v-bind:to="{name: 'FailedPost'}">Failed Posts</router-link></li>

                </ul>
            </li> -->
            <li v-show="userPermissions.indexOf('allow_manager_tool_box') > -1" id="li_manager_tool_box" class="">
                <label class="tree-toggle nav-header">
                    <span class="fa-stack fa-lg pull-left">
                        <i class="fa fa-cogs fa-stack-1x"></i>
                    </span> Manager Tool Box <i class="fa fa-angle-down" aria-hidden="true"></i>
                </label>
                <ul id="ul_manager_tool_box" class="nav nav-list tree" style="display: none;">
                    <li id="timeline">
                        <router-link v-bind:to="{name: 'ListFolder'}">Folder</router-link>
                    </li>
                    <li id="timeline">
                        <router-link v-bind:to="{name: 'ListManagerToolBox'}">Documents</router-link>
                    </li>
                    <!-- <li id="timeline">
                        <router-link v-bind:to="{name: 'ListManagerToolBoxByID'}">Documents</router-link>
                    </li> -->
                </ul>
                <!-- <router-link v-bind:to="{name: 'ListManagerToolBox'}">
                    <span class="fa-stack fa-lg pull-left">
                        <i class="fa fa-cogs fa-stack-1x "></i>
                    </span>Manager Tool Box
                </router-link> -->
            </li>
        </ul>
    </div>
    <!-- /#wrapper -->
</template>

<script>
    import Vue from "vue";
    import EventBus from '../../event-bus';
    import SessioMixin from '../../../mixins/sessionmixin';
    var self;
    export default {
        name: 'Sidebar',
        props: [''],
        components: {},
        mixins: [SessioMixin],
        data() {
            return {
                isShowLoggedinfields: true,
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',

            }
        },
        beforeMount: function () {
            self = this;
            //console.log("before mount");
        },
        mounted: function () {
            EventBus.$emit("sidebarType", 'back-end');
            /*$("#menu-toggle").on("click", function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").on("click", function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });*/

            $('.tree-toggle').click(function () {
                /*$('ul.tree').hide();*/
                $(this).parent().children('ul.tree').toggle(200);
                if ($(this).children().eq(1).attr('class').indexOf('fa-angle-down') != -1) {
                    $(this).children().eq(1).addClass('fa-angle-up');
                    $(this).children().eq(1).removeClass('fa-angle-down');
                } else {
                    $(this).children().eq(1).removeClass('fa-angle-up');
                    $(this).children().eq(1).addClass('fa-angle-down');
                }
            });
            /*console.log(this.checkLogin());*/
        },
        methods: {
            initMenu: function () {
                $('#menu ul').hide();
                $('#menu ul').children('.current').parent().show();
                //$('#menu ul:first').show();
                $('#menu li a').click(
                        function () {
                            var checkElement = $(this).next();
                            if ((checkElement.is('ul')) && (checkElement.is(':visible'))) {
                                return false;
                            }
                            if ((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
                                $('#menu ul:visible').slideUp('normal');
                                checkElement.slideDown('normal');
                                return false;
                            }
                        }
                );
            }
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;

            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/partials/Sidebar.vue